<!-- src/components/ViewCommitmentModal.vue -->
<template>
  <div ref="modalEl" class="modal fade" id="viewCommitmentModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Commitment</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="text-center text-muted py-4">
            <i class="bi bi-hourglass-split me-2"></i>Loading…
          </div>

          <div v-else-if="error" class="alert alert-danger py-2 mb-0">
            {{ error }}
          </div>

          <div v-else>
            <div class="mb-3">
              <div class="text-muted small">Member</div>
              <div class="fw-semibold">{{ member?.name || "—" }}</div>
              <div class="text-muted small">
                {{ member?.phone || member?.email || "—" }}
              </div>
            </div>

            <div v-if="commitment" class="row g-3">
              <div class="col-6">
                <div class="text-muted small">Amount / month</div>
                <div class="fw-bold">{{ formatMoney(commitment.amount) }}</div>
              </div>

              <div class="col-6">
                <div class="text-muted small">Status</div>
                <span class="badge" :class="commitment.status === 'active' ? 'text-bg-success' : 'text-bg-secondary'">
                  {{ commitment.status }}
                </span>
              </div>

              <div class="col-12">
                <div class="text-muted small">Cycle</div>
                <div class="fw-semibold">
                  {{ commitment.cycle_start_period || "—" }} → {{ commitment.cycle_end_period || "—" }}
                </div>
              </div>

              <div class="col-6">
                <div class="text-muted small">Cycle months</div>
                <div class="fw-semibold">{{ commitment.cycle_months ?? "—" }}</div>
              </div>

              <div class="col-6">
                <div class="text-muted small">Activated at</div>
                <div class="fw-semibold">{{ formatDateTime(commitment.activated_at) }}</div>
              </div>
            </div>

            <div v-else class="alert alert-warning py-2 mb-0">
              Commitment not found for the selected period.
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/services/http";
import { Modal } from "bootstrap";

export default {
  name: "ViewCommitmentModal",

  data() {
    return {
      modal: null,
      loading: false,
      error: "",
      member: null,
      period: null, // "YYYY-MM"
      commitment: null,
    };
  },

  methods: {
    formatMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },

    formatDateTime(v) {
      if (!v) return "—";
      // handles ISO string from Laravel
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return String(v);
      return d.toLocaleString();
    },

    async open(member, period) {
      this.member = member || null;
      this.period = period || null;

      this.loading = true;
      this.error = "";
      this.commitment = null;

      if (!this.modal) {
        this.error = "Modal not initialized.";
        this.loading = false;
        return;
      }

      this.modal.show();

      try {
        if (!member?.id) throw new Error("Member not provided.");
        if (!period) throw new Error("Period not provided.");

        // Your backend route: GET /commitments/active?user_id=1&period=2024-03
        const res = await http.get("/commitments/active", {
          params: { user_id: member.id, period },
        });

        this.commitment = res?.data?.data || null;

        if (!this.commitment) {
          // backend returns {data: null} when none
          this.error = "No active commitment found for this period.";
        }
      } catch (e) {
        this.error = e?.response?.data?.message || e?.message || "Failed to load commitment.";
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    const el = this.$refs.modalEl;
    if (!el) return;

    // IMPORTANT: create modal from ref element (avoids backdrop/config errors)
    this.modal = Modal.getOrCreateInstance(el);

    el.addEventListener("hidden.bs.modal", () => {
      this.loading = false;
      this.error = "";
      this.member = null;
      this.period = null;
      this.commitment = null;
    });
  },
};
</script>

<style scoped>
/* optional: tighter on small screens */
@media (max-width: 576px) {
  :deep(.modal-dialog) {
    margin: 0.75rem;
  }
}
</style>